module.exports = __webpack_public_path__ + "img/turin_2.8486bbd0.png";